var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rotate-right 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.6045 11.9901C19.9808 11.9957 19.4566 12.4604 19.3764 13.0792C18.7821 17.1404 15.0088 19.9509 10.9485 19.3565C6.8882 18.762 4.07842 14.9879 4.67269 10.9266C5.26696 6.86536 9.04026 4.05492 13.1006 4.64933C14.4846 4.85194 15.7833 5.44121 16.8474 6.34938L15.9153 7.28168C15.5933 7.60391 15.5933 8.12631 15.9155 8.44846C16.0707 8.60369 16.2814 8.69063 16.5009 8.69001H20.2837C20.7392 8.69001 21.1085 8.32064 21.1085 7.86499V4.08137C21.1084 3.62572 20.739 3.25643 20.2835 3.25651C20.0648 3.25655 19.8551 3.34345 19.7005 3.49806L18.6018 4.59701C14.5142 0.974699 8.2648 1.35262 4.6433 5.44117C1.0218 9.52973 1.39971 15.7806 5.48727 19.403C9.57483 23.0253 15.8243 22.6474 19.4458 18.5588C20.7206 17.1195 21.5484 15.3398 21.8278 13.4373C21.9371 12.7561 21.4737 12.1153 20.7928 12.0059C20.7305 11.9959 20.6676 11.9906 20.6045 11.9901Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReload);
export default __webpack_public_path__ + "static/media/icon_reload.16b4994ff90240fac1bbd350be04f7af.svg";
export { ForwardRef as ReactComponent };